import { Component, EventEmitter, Input, OnInit, OnChanges, Output, SimpleChanges } from '@angular/core';

import * as _ from 'lodash';

@Component({
    selector: 'gf-choice-buttons',
    template: require('./choice-buttons.component.html')
})
export class ChoiceButtonsComponent implements OnInit, OnChanges {

    @Input() choices: any = {};
    @Input() choice: any = null;
    @Input() gfClass: any;
    @Input() readOnly: boolean = false;

    @Output() onChange = new EventEmitter();

    protected displayList = [];

    constructor() { }

    ngOnInit() { };

    ngOnChanges(): void {
        this.displayList = this.createDisplayList(this.choices);
        }
    select(newValue) {
        if (this.readOnly) return false;
        if (newValue == undefined || this.choice == newValue) return false;

        this.onChange.emit(newValue);
}

    createDisplayList(choices: any) {
        return _.keys(choices).map((key: string) => {
            return {
                            label: key,
                            value: choices[key]
            };

        });
    }
}
